"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getItineraryCheapestGolfCombination = void 0;
const _ = require("lodash");
const course_1 = require("../course");
const orders_1 = require("../orders");
const getItineraryCheapestGolfCombination = (course_list, rate_matrix, course_itinerary, duration) => {
    if (!course_list || !rate_matrix || !course_itinerary || !duration)
        return [];
    const course_distribution = course_itinerary.length === 0
        ? (0, course_1.getGolfDayDistribution)(course_itinerary.filter((item) => item !== null && item !== undefined)
            .length, duration) || [true]
        : course_itinerary.map((golf) => (golf ? true : false));
    const matrix = rate_matrix.map(({ date, courses }) => courses.length > 0 && {
        date,
        courses: courses.map((course) => ({
            id: course.config.course.id,
            name: course.config.course.name,
            players: course.config?.where_when_who?.number_of_golfers,
            rate: (0, orders_1.getOrderLineTotalByType)(course.config, "GOLF"),
            rate_message: course.message,
        })),
    });
    matrix.forEach((m, i) => {
        if (!course_distribution[i]) {
            m?.courses?.forEach((c) => {
                c.rate = 0;
            });
        }
    });
    const ideal_order = _.cloneDeep(course_list);
    const cheapest_combination = (0, course_1.findCheapestCombination)(ideal_order.reverse(), course_itinerary
        .map((x) => x?.config?.course?.id)
        .filter((id) => id !== undefined), matrix);
    return cheapest_combination;
};
exports.getItineraryCheapestGolfCombination = getItineraryCheapestGolfCombination;
